import { EntityEnvironment } from "@dinahmoe/dmafjs-core";
import { eNodes } from "../nodes.js";
import { entities } from "../entities.js";

class NodeHtml extends EntityEnvironment {
  handlers = this.extendParentHandlers({
    destination: { handler: this.updateDestination, type: "string" },
  });
  prevDestination = "";

  constructor(name) {
    super(name);
    entities.set(name, this);
  }

  create(dnode) {
    this.setProps(dnode);
  }

  setProps(dnode) {
    dnode.sources = new Map();
    for (const key of Object.keys(dnode.props)) {
      const entry = dnode.envImplementation.handlers[key];
      if (entry) {
        const handler = typeof entry === "function" ? entry : entry.handler;
        handler.call(dnode.envImplementation, dnode);
      }
      if (typeof dnode.envImplementation[key] === "function") {
        dnode.envImplementation[key](dnode);
      }
    }
  }

  addSource({ dnode, destinationDnode }) {
    dnode.sources.set(destinationDnode.uid, destinationDnode);
  }

  removeSource(dnode) {
    dnode.sources.delete(dnode.uid);
  }

  updateDestination(dnode) {
    const newDestination = dnode.props.destination;
    const destinationDnode = eNodes.get(newDestination);

    if (this.prevDestination.length === 0) {
      this.prevDestination = newDestination;
      this.setDestination({ dnode, destinationDnode });
      return;
    }

    const prevDestinationDnode = eNodes.get(this.prevDestination);
    prevDestinationDnode.envImplementation.removeSource(prevDestinationDnode);
    this.prevDestination = newDestination;
    this.setDestination({ dnode, destinationDnode });
  }

  setDestination({ dnode, destinationDnode }) {
    if (!destinationDnode?.input || !dnode.output) {
      return;
    }

    dnode.output.connect(destinationDnode.input);
    destinationDnode.envImplementation.addSource({ dnode, destinationDnode });
  }

  destroy(dnode) {
    if (!dnode) {
      return;
    }

    this.prevDestination = "";
    dnode.output?.disconnect();
    this.removeSources(dnode.sources);
  }

  // TODO recursive destroy sources
  removeSources(sources) {
    if (sources.size === 0) {
      return;
    }

    const nestedSourcesEmpty = Array.from(sources, (source) => source[1]).every(
      (source) => source.sources.size === 0,
    );

    if (nestedSourcesEmpty) {
      sources.forEach((source) => source.envImplementation.destroy());
      return;
    }

    sources.forEach((source) => {
      if (source.sources.size === 0) {
        return;
      }

      return this.removeSources.call(this, source.sources);
    });
  }
}

const nodeHtml = new NodeHtml("webaudio:node");
export { nodeHtml, NodeHtml };
